/*
// Target Range
var xMin = 1;
var xMax = 100;

// Input Range
var yMin = 300.77;
var yMax = 559.22;

var value = convert(302, xMin, xMax, yMin, yMax)
console.log(value)
*/

export function convert(inputY, xMin, xMax, yMin, yMax) {
  var percent = (inputY - yMin) / (yMax - yMin);
  var output = percent * (xMax - xMin) + xMin;
  return output
}


export function calculateBuyRange(currentPrice,frozenPrice, lowBuyRange, highBuyRange,date,practicalReturn, theoreticalValuation,practicalValuation) {
  let id;
  let name;

const todayDate = Date();
const todayMs = Date.parse(todayDate);
const dateMs = Date.parse(date);
const Diff = todayMs - dateMs;
const divideBy = 86400000;  //milliseconds in a day
const dayDiff = (Diff / divideBy);

const practicalReturnPercent = practicalReturn/100;
const planPriceDispersion = (((lowBuyRange + highBuyRange) / 2) - lowBuyRange) / ((lowBuyRange + highBuyRange) / 2)
const highSideAmplifier = (((1+practicalReturnPercent)**1.5)-1)*(2*(Math.max(1,Math.min(1.5,(theoreticalValuation/practicalValuation)))-1))
const indexedPlanPrice = frozenPrice * ((1+practicalReturnPercent)**(dayDiff/365));
 
//const transitionPriceS = indexedPlanPrice * (1+(-1.75 * planPriceDispersion))
const transitionPrice1 = indexedPlanPrice * (1+(-1.50 * planPriceDispersion))
const transitionPrice2 = indexedPlanPrice * (1+(-0.75 * planPriceDispersion))
 
//const transitionPrice3 = indexedPlanPrice * (1+(-0.75 * planPriceDispersion))
const transitionPrice4 = indexedPlanPrice * (1+(0.00 * planPriceDispersion))
//const transitionPrice5 = indexedPlanPrice * (1+(1.00 * planPriceDispersion))
 
const transitionPrice6 = indexedPlanPrice * (1+(1.00 * planPriceDispersion)) * (1+highSideAmplifier)
const transitionPrice7 = indexedPlanPrice * (1+(1.50 * planPriceDispersion)) * (1+highSideAmplifier)
//const transitionPriceE = indexedPlanPrice * (1+(1.75 * planPriceDispersion)) * (1+highSideAmplifier)


  if (currentPrice <= transitionPrice1-.01) {
    id = 'sellLow'
    name = 'Sell'
  } else if (transitionPrice1 <= currentPrice && currentPrice < transitionPrice2-.01) {
    id = 'watchLow'
    name = 'Watch'
  } else if (transitionPrice2 <= currentPrice && currentPrice <= transitionPrice6-.01) {
    id = 'buy'
    name = 'Buy'
  } else if (transitionPrice6 <= currentPrice && currentPrice <= transitionPrice7-.01) {
    id = 'watchHigh'
    name = 'Watch'
  } else if (currentPrice >= transitionPrice7) {
    id = 'sellHigh'
    name = 'Sell'
  }


  
  return {
    id,
    name,
    transitionPrice1,
    transitionPrice2,
    transitionPrice4,
    transitionPrice6,
    transitionPrice7,
  }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js